export default "__VITE_ASSET__CEEU9JPE__"